import React from 'react';
import { Header as SiteNavigation } from '@app/components/header/Header';
import { Layout } from 'antd';
const { Content } = Layout;
import type { Me } from '@app/services/auth.types';

export type PageProps = {
	children: React.ReactNode;
	className?: string;
	centered?: boolean;
	showNav?: boolean;
	showBreadcrumb?: boolean;
	user?: Me;
	onLogin?: () => void;
	onLogout?: () => void;
	onLogoClick?: () => void;
};

export const Page = ({ showNav = true, children, onLogin, onLogout, onLogoClick }: PageProps) => {
	return (
		<Layout style={{ height: '100svh', overflow: 'auto' }}>
			{showNav ? (
				<SiteNavigation
					showHandle
					onLogin={onLogin}
					onLogout={onLogout}
					onLogoClick={onLogoClick}
				/>
			) : null}

			<Layout>
				<Content className="page-wrapper">{children}</Content>
			</Layout>
		</Layout>
	);
};

export default Page;
